import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ShoppingItem } from '@homeapp/shared';
import ShoppingItemRow from './ShoppingItem';

interface Props {
  activeItems: ShoppingItem[];
  boughtItems: ShoppingItem[];
  onToggle: (itemId: string, status: string) => void;
  onDelete: (itemId: string) => void;
}

export default function ShoppingList({ activeItems, boughtItems, onToggle, onDelete }: Props) {
  const { t } = useTranslation();
  const [showBought, setShowBought] = useState(true);

  return (
    <div className="space-y-4">
      {/* Active items */}
      <section>
        <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
          {t('shopping.active')} ({activeItems.length})
        </h2>
        {activeItems.length === 0 ? (
          <p className="text-gray-400 text-center py-8">{t('shopping.noItems')}</p>
        ) : (
          <div className="space-y-2">
            {activeItems.map(item => (
              <ShoppingItemRow
                key={item.itemId}
                item={item}
                onToggle={() => onToggle(item.itemId, item.status)}
                onDelete={() => onDelete(item.itemId)}
              />
            ))}
          </div>
        )}
      </section>

      {/* Bought items */}
      {boughtItems.length > 0 && (
        <section>
          <button
            onClick={() => setShowBought(!showBought)}
            className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2 flex items-center gap-1"
          >
            <span className={`transition-transform ${showBought ? 'rotate-90' : ''}`}>▶</span>
            {t('shopping.bought')} ({boughtItems.length})
          </button>
          {showBought && (
            <div className="space-y-2">
              {boughtItems.map(item => (
                <ShoppingItemRow
                  key={item.itemId}
                  item={item}
                  onToggle={() => onToggle(item.itemId, item.status)}
                  onDelete={() => onDelete(item.itemId)}
                />
              ))}
            </div>
          )}
        </section>
      )}
    </div>
  );
}
